import { ReactNode } from 'react';

import { ReactComponent as QuestionMarkIcon } from 'assets/staking/question-mark.svg';

import { Tooltip } from './Tooltip';

type InfoTooltipProps = {
  content: ReactNode;
  size?: number;
  position?: 'top' | 'bottom' | 'left' | 'right';
  width?: number;
  contentClassName?: string;
};

export const InfoTooltip = ({ content, size = 24, position = 'top', width, contentClassName }: InfoTooltipProps) => {
  return (
    <Tooltip content={content} position={position} width={width} contentClassName={contentClassName}>
      <QuestionMarkIcon width={size} height={size} />
    </Tooltip>
  );
};
